/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {UserLocaleSaveRequest} from '../models/UserLocaleSaveRequest';

export interface UpdateUserLocale$Request {
    userId: number;
    userLocaleSaveRequest: UserLocaleSaveRequest;
}

export interface UpdateUserLocale$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updateUserLocaleRequest = createAction<PayloadData<void, UpdateUserLocale$Request>>('UPDATE_USER_LOCALE__UPDATE_USER_LOCALE__REQUEST');
export const updateUserLocaleSuccess = createAction<PayloadData<void, UpdateUserLocale$Request>>('UPDATE_USER_LOCALE__UPDATE_USER_LOCALE__SUCCESS');
export const updateUserLocaleFailure = createAction<PayloadData<Error, UpdateUserLocale$Request, true>>('UPDATE_USER_LOCALE__UPDATE_USER_LOCALE__FAILURE');

export const updateUserLocaleActions = [
    updateUserLocaleRequest,
    updateUserLocaleSuccess,
    updateUserLocaleFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {UserLocaleSaveRequest} meta.userLocaleSaveRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updateUserLocale = (meta: UpdateUserLocale$Request, config?: UpdateUserLocale$Config) => {
    return {
        CALL_API: {
            types: updateUserLocaleActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/users/${meta.userId}/locale`,
            TRANSPORT_REQUEST_BODY: meta.userLocaleSaveRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

